import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
const DisableCopyPaste = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    console.log("Current Path:", location.pathname);
    // :white_check_mark: Allow copy-paste on "/"
    if (location.pathname === "/") {
      return;
    }
    const handleCopy = (e) => {
      e.preventDefault();
      toast.warning("Copy/pasting is not allowed");
    };
    const handlePaste = (e) => {
      e.preventDefault();
      toast.warning("Copy/pasting is not allowed");
    };
    const handleCut = (e) => {
      e.preventDefault();
      toast.warning("Copy/pasting is not allowed");
    };
    document.addEventListener("copy", handleCopy);
    document.addEventListener("paste", handlePaste);
    document.addEventListener("cut", handleCut);
    // :white_check_mark: cleanup when route changes
    return () => {
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("paste", handlePaste);
      document.removeEventListener("cut", handleCut);
    };
  }, [location.pathname]); // :fire: KEY FIX
  return <>{children}</>;
};
export default DisableCopyPaste;







